import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from './pages/Home.vue'
import Subsea from './pages/Subsea.vue'
import Equipment from './pages/Equipment.vue'

Vue.use(VueRouter)

const routes = [
  {path: '/', component: Home},
  {path: '/equipment', component: Equipment},
  {path: '/subsea', component: Subsea}
]

const router = new VueRouter({
  routes
})

export default router
